import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { ClassAssignmentStoreModel } from './class-assignment.model';

export type ClassAssignmentState = EntityState<ClassAssignmentStoreModel>;

@Injectable({ providedIn: 'root' })
export class ClassAssignmentStore extends EntityStore<ClassAssignmentState, ClassAssignmentStoreModel, 'id'> {
  constructor() {
    super({
      name: 'class-assignments',
      idKey: 'id',
    });
  }
}
